import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=50b6630a&scoped=true"
import script from "./baseEdit.vue?vue&type=script&lang=js"
export * from "./baseEdit.vue?vue&type=script&lang=js"
import style0 from "./baseEdit.vue?vue&type=style&index=0&id=50b6630a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b6630a",
  null
  
)

export default component.exports